import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ControlValueAccessor, NgControl, NgModel, Validators } from '@angular/forms';
import { getRandomId } from 'src/app/shared/extensions/string.extensions';
import { ValidationDisplayType } from './validation-display-type';

@Component({
    selector: 'app-standard-textbox',
    templateUrl: './standard-textbox.component.html',
    styleUrls: ['./standard-textbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StandardTextboxComponent implements ControlValueAccessor, OnInit {
    public control = inject(NgControl, { self: true, optional: true });

    @Input() public addOnText?: string;
    @Input() public label: string;
    @Input() public hint: string;
    @Input() public disabled = false;
    @Input() public validationError: string;
    @Input() public replaceTextbox: boolean;
    @Input() public maxLength = 128;
    @Input() public set focus(value: boolean) {
        this._focus = value;
        this.handleFocus();
    }
    @Input() public validationDisplayType: ValidationDisplayType = ValidationDisplayType.StandardValidation;

    public id: string;
    public data: string | number | boolean;
    public validationDisplayTypes = ValidationDisplayType;
    public hasBoundFormControl = false;

    private _focus: boolean;
    @ViewChild('standardTextbox', { static: true }) private standardTextbox: ElementRef;

    constructor() {
        if (this.control) {
            this.hasBoundFormControl = !(this.control instanceof NgModel);
            this.control.valueAccessor = this;
        }
        this.id = getRandomId();
    }

    public ngOnInit(): void {
        this.setValidators();
        this.handleFocus();
    }

    private setValidators() {
        if (!this.control?.control) {
            return;
        }

        const defaultValidators = [Validators.maxLength(this.maxLength)];
        const validators = this.control.control.validator ? [this.control.control.validator, ...defaultValidators] : defaultValidators;

        this.control.control.setValidators(validators);
        this.control.control.updateValueAndValidity();
    }

    private handleFocus() {
        if (this._focus) {
            this.standardTextbox.nativeElement.focus();
        }
    }

    public onChangeFn = (_: string | number | boolean) => {
        return;
    };

    public onTouchedFn = () => {
        return;
    };

    public writeValue(value: string | number | boolean): void {
        if (value != null && !Number.isNaN(value)) {
            this.data = value;
        } else {
            this.data = null;
        }
    }

    public registerOnChange(fn: () => void): void {
        this.onChangeFn = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouchedFn = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    public onChange() {
        this.onChangeFn(this.data);
    }
}
